import angular from 'angular';
import customersComponent from './customers.component';

let customersModule = angular.module('customers', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('customers', customersComponent);

export default customersModule;



// WEBPACK FOOTER //
// ./client/pages/admin/customers/customers.js